export const shallowEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) {
    return false
  }

  for (let i = 0; i < arr1.length; i += 1) {
    if (arr1[i] !== arr2[i]) {
      return false
    }
  }

  return true
}

// Based on the Fisher-Yates shuffle algorithm
// https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle
export const shuffleArray = array => {
  for (let i = array.length; i > 1; i -= 1) {
    const index = Math.floor(Math.random() * i)
    const temp = array[i - 1]
    array[i - 1] = array[index]
    array[index] = temp
  }

  return array
}
